import React, { useContext, useState } from 'react';
import {
    Box,
    Avatar,
    Typography,
    TextField,
    MenuItem,
    IconButton,
    Menu,
    MenuItem as MuiMenuItem,
    Button
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import '../../assets/styles/header.scss';
import { CommonContext } from '../../context';
import { Link, useNavigate } from 'react-router-dom';
import { AccountBalance, Calculate, CurrencyRupee, Download } from '@mui/icons-material';
import ShippingRechargeModal from '../common/ShippingRechargeModal';
import MerchantDetails from '../merchants/details/MerchantDetails';
import Logo from '../../logo.png';

import MenuIcon from '@mui/icons-material/Menu';

const Header = ({ isSidebarCollapsed = true, onDrawerToggle, isMobile }) => {
    const { user, globalSearch, setGlobalSearch, walletAmount, detailsToggleDrawer } = useContext(CommonContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    const handleSearch = () => {
        setGlobalSearch((prev) => ({ ...prev, searchTrigger: prev.searchTrigger + 1 }));
        if (globalSearch?.type === 'B2C') {
            navigate(`/orders/b2c`);
        } else {
            navigate(`/orders/b2b`);
        }
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        localStorage.clear();
        navigate('/admin');
    };

    return (
        <>
            <MerchantDetails />
            <Box className="custom-header">
                {isMobile && (
                    <IconButton color="inherit" onClick={onDrawerToggle} sx={{ ml: 1 }}>
                        <MenuIcon />
                    </IconButton>
                )}
                {!isMobile && (
                    <Box
                        component="img"
                        src={Logo}
                        alt="Logo"
                        sx={{ width: 50, height: 50, objectFit: "contain", marginLeft: '0.5rem' }}
                    />
                )}

                <Box className="header-search" sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: isMobile ? 'center' : 'flex-end',
                    gap: isMobile ? 1 : 0
                }}>
                    {!isMobile && (
                        <>
                            <Button
                                component={Link}
                                to="/download"
                                variant="outlined"
                                size="medium"
                                startIcon={<Download />}
                                sx={{
                                    textTransform: 'none',
                                    marginRight: '0.5rem',
                                    borderColor: '#ccc',
                                    color: '#fff',
                                    height: '36.5px',
                                    '&:hover': {
                                        borderColor: '#999',
                                        backgroundColor: 'rgba(0,0,0,0.03)',
                                    },
                                    '& .MuiButton-startIcon': {
                                        marginRight: '0rem',
                                    },
                                }}
                            />
                            <Button
                                component={Link}
                                to="/price-calculator"
                                variant="outlined"
                                size="medium"
                                startIcon={<Calculate />}
                                sx={{
                                    textTransform: 'none',
                                    marginRight: '0.5rem',
                                    borderColor: '#ccc',
                                    color: '#fff',
                                    height: '36.5px',
                                    '&:hover': {
                                        borderColor: '#999',
                                        backgroundColor: 'rgba(0,0,0,0.03)',
                                    },
                                }}
                            >
                                Price Calculator
                            </Button>
                            {user?.user_type === "Merchant" ? (
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ShippingRechargeModal />
                                    <Button
                                        component={Link}
                                        to="/recharge"
                                        variant="outlined"
                                        size="medium"
                                        startIcon={<CurrencyRupee />}
                                        sx={{
                                            textTransform: 'none',
                                            marginRight: '0.5rem',
                                            borderColor: '#ccc',
                                            color: '#fff',
                                            height: '36.5px',
                                            '&:hover': {
                                                borderColor: '#999',
                                                backgroundColor: 'rgba(0,0,0,0.03)',
                                            },
                                        }}
                                    >
                                        {walletAmount?.total_balance || 0}
                                    </Button>
                                </Box>
                            ) : (
                                <Button
                                    component={Link}
                                    to="/recharge"
                                    variant="outlined"
                                    size="medium"
                                    startIcon={<AccountBalance />}
                                    sx={{
                                        textTransform: 'none',
                                        marginRight: '0.5rem',
                                        borderColor: '#ccc',
                                        color: '#fff',
                                        height: '36.5px',
                                        '&:hover': {
                                            borderColor: '#999',
                                            backgroundColor: 'rgba(0,0,0,0.03)',
                                        },
                                    }}
                                >
                                    Wallet
                                </Button>
                            )}
                        </>
                    )}

                    <Box className="search-container" sx={{
                        width: isMobile ? '100%' : 'auto',
                        maxWidth: isMobile ? '280px' : 'none',
                        flexGrow: 0
                    }}>
                        <TextField
                            select
                            value={globalSearch.type}
                            onChange={(e) =>
                                setGlobalSearch((prev) => ({ ...prev, type: e.target.value }))
                            }
                            variant="standard"
                            className="search-select"
                            SelectProps={{
                                disableUnderline: true,
                            }}
                        >
                            <MenuItem value="B2C">B2C</MenuItem>
                            <MenuItem value="B2B">B2B</MenuItem>
                        </TextField>

                        <TextField
                            placeholder={isMobile ? (globalSearch?.type === 'B2B' ? "LR No." : "AWB No.") : (globalSearch?.type === 'B2B' ? "Search By LR No." : "Search By AWB No.")}
                            value={globalSearch.value}
                            onChange={(e) =>
                                setGlobalSearch((prev) => ({ ...prev, value: e.target.value }))
                            }
                            variant="standard"
                            className="search-input"
                            InputProps={{
                                disableUnderline: true,
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearch();
                                }
                            }}
                        />

                        <IconButton onClick={handleSearch} className="search-btn">
                            <SearchIcon />
                        </IconButton>
                    </Box>
                </Box>

                <Box className="header-right">
                    {!isMobile && (
                        <Box className="user-info">
                            <Typography className="user-name">{user?.name}</Typography>
                            {user?.user_type !== 'Merchant' && user?.id !== 1 && user?.emp_code && (
                                <Typography variant="caption" display="block" sx={{ fontSize: '0.75rem' }}>
                                    {user.emp_code}
                                </Typography>
                            )}
                            <Typography className="user-store">{user?.store}</Typography>
                        </Box>
                    )}
                    <Avatar
                        onClick={handleMenuOpen}
                        sx={{ cursor: 'pointer' }}
                    >
                        {user?.name?.charAt(0) || 'N'}
                    </Avatar>

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        {isMobile && (
                            <Box sx={{ px: 2, py: 1, borderBottom: '1px solid #eee' }}>
                                <Typography variant="subtitle2" fontWeight="bold">{user?.name}</Typography>
                                {user?.user_type !== 'Merchant' && user?.id !== 1 && user?.emp_code && (
                                    <Typography variant="caption" display="block" color="textSecondary">
                                        {user.emp_code}
                                    </Typography>
                                )}
                                <Typography variant="caption" color="textSecondary">{user?.store}</Typography>
                            </Box>
                        )}
                        <MuiMenuItem onClick={() => { handleMenuClose(); detailsToggleDrawer(); }}>Site Setting</MuiMenuItem>
                        {isMobile && (
                            <>
                                <MuiMenuItem component={Link} to="/download" onClick={handleMenuClose}>Download</MuiMenuItem>
                                <MuiMenuItem component={Link} to="/price-calculator" onClick={handleMenuClose}>Price Calculator</MuiMenuItem>
                                <MuiMenuItem component={Link} to="/recharge" onClick={handleMenuClose}>
                                    {user?.user_type === "Merchant" ? `Wallet: ${walletAmount?.total_balance || 0}` : 'Wallet'}
                                </MuiMenuItem>
                            </>
                        )}
                        <MuiMenuItem onClick={handleLogout}>Logout</MuiMenuItem>
                    </Menu>
                </Box>
            </Box>
        </>
    );
};

export default Header;
